import {Component, OnInit} from "@angular/core";
import {Base} from "../../../../../../common/interfaces/base.interfaces";
import {Order} from "../../../../../../common/interfaces/order.interface";


@Component({
    selector: "section-order-list-open",
    template: `
        <section-order-list [params]="params"></section-order-list>`
})
export class OrderListOpenComponent implements Base.IComponent, OnInit {

    public readonly state: Base.IState;

    public params: Order.IOrderListParams;

    public constructor() {
    }

    public ngOnInit(): void {
        this.params = {
            title: "Open orders list",
            state: this.state,
            actions: {
                view: true,
                delete: true,
                add: false,
                export: true,
                remarks: true
            },
            query: {status_parameter_open: true}
        };
    }

    public ngConfig(): Base.IConfig {
        return {
            name: "orders-open",
            actions: {
                "browse": ["browse_orders"]
            }
        };
    }

}
